import {
  FETCH_ALL_USERS,
  FETCH_ALL_USERS_SUCCESS,
  FETCH_ALL_USERS_FAILED,
  EDIT_USER_SUCCESS,
  EDIT_USER,
  EDIT_USER_FAILED
} from "../store/types";

export const INITIAL_STATE = {
  users: null,
  loading: false,
  load: false,
  error: {
    flag: false,
    msg: null
  }
}

export const usersreducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_ALL_USERS:
      return {
        ...state,
        loading: true,
      };
    case EDIT_USER:
      return {
        ...state,
        loading: true,
        //load: true
      };
    case EDIT_USER_FAILED:
      return {
        ...state,
        loading: false,
        load:false
      };
    case EDIT_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        load: true
      };
    case FETCH_ALL_USERS_SUCCESS:
      return {
        ...state,
        users: action.payload,
        loading: false
      };
    case FETCH_ALL_USERS_FAILED:
      return {
        ...state,
        users: null,
        loading: false,
        error: {
          flag: true,
          msg: action.payload
        }
      };
    default:
      return state;
  }
};